import { render } from "./ActorTable.vue?vue&type=template&id=fa76c56e&scoped=true"
import script from "./ActorTable.vue?vue&type=script&lang=js"
export * from "./ActorTable.vue?vue&type=script&lang=js"

import "./ActorTable.vue?vue&type=style&index=0&id=fa76c56e&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa76c56e"]])

export default __exports__